import { useModal } from 'Hooks/useModal';
import PreviewReportModal from 'Pages/Report/PreviewReport/PreviewReportModal';
import CloneReportModal from './CloneReportModal';
import DeleteReportModal from './DeleteReportModal';
import { ReportModalAction, ReportModalsPropsBase } from './ReportModals.types';
import { useEffect } from 'react';

function ReportModals(props: ReportModalsPropsBase) {
	const { isMobile } = props;
	const { modal, hideModal } = useModal();

	useEffect(() => {
		if(isMobile && modal?.name === ReportModalAction.Preview) hideModal();
	}, [isMobile, modal])
	
	if (!modal) return null;
	return (
		<>
			{modal.name === ReportModalAction.Preview && <PreviewReportModal />}
			{modal.name === ReportModalAction.Delete && <DeleteReportModal />}
			{modal.name === ReportModalAction.Clone && <CloneReportModal {...props} />}
		</>
	);
}

export default ReportModals;
